//一覧ページチェックボックス関連
document.addEventListener("DOMContentLoaded", function () {
  const allCheckboxes = document.querySelectorAll(
    ".p-experience-search__selection .check-all"
  );

  allCheckboxes.forEach(function (allCheckbox) {
    const itemCheckboxes = document.querySelectorAll(
      `.p-experience-search__selection .check-item`
    );

    // 「すべて」が変更されたときの挙動
    allCheckbox.addEventListener("change", function () {
      itemCheckboxes.forEach(function (itemCheckbox) {
        itemCheckbox.checked = allCheckbox.checked;
      });
    });

    // グループ内のアイテムの挙動
    itemCheckboxes.forEach(function (itemCheckbox) {
      itemCheckbox.addEventListener("change", function () {
        // 全てチェックされていれば「すべて」にチェックを入れる
        if ([...itemCheckboxes].every((checkbox) => checkbox.checked)) {
          allCheckbox.checked = true;
        } else {
          // いずれかのアイテムが外れた場合、「すべて」のチェックを外す
          allCheckbox.checked = false;
        }
      });
    });
  });

  //地域のチェックボックスは複数選択不可
  const checkGet = document.querySelectorAll(
    '.check-item[data-group="group1"], .check-all[data-group="group1"]'
  );
  checkGet.forEach((check) => {
    check.addEventListener("change", () => {
      if (check.checked) {
        setTimeout(() => {
          checkGet.forEach((allChecks) => {
            allChecks.checked = false;
          });
          check.checked = true;
        }, 0);
      }
    });
  });
});